module.exports = __webpack_public_path__ + "static/media/longest-drive.82d638c2.png";